export default __webpack_public_path__ + "static/media/P20015.a6bb9383.png";